<template lang="pug">
    MatchMedia(v-slot='{ screenSM }')
        .re-cart-list(:class="getComponentClasses()")
            .modals
                re-modal(
                    v-if="showClearCartModal"
                    :containerClass="['re-modal-md', 'clear-cart-modal']"
                    @close="finallyDontCleanCurrentCart"
                )
                    p.re-modal-title {{ clearCartModalMessage }}
                    .re-modal-buttons
                        re-button(
                            classes="btn-confirm"
                            @click="finallyCleanCurrentCart"
                            id="yesClearCart") {{ clearCartModalConfirmLabel }}
                        re-button(
                            classes="btn-deny"
                            @click="finallyDontCleanCurrentCart"
                            id="dontClearCart") {{ clearCartModalDenyLabel }}
            .re-cart-container
                .re-cart-list-header
                    .cart-items-header-items
                        .header-item Product
                        .header-item Name
                        .header-item.center Quantity
                        .header-item.center Price
                .re-cart-list-content
                    .re-cart-items
                        .re-cart-item(v-for="item in displayedCartItems" :key="item.id" :class="getCartItemClass(item)")
                            .re-cart-container-box
                                .re-cart-item-media
                                    .re-cart-item-image(:style="getItemImageStyle(item.attributes.image)")
                                        img(v-if="!item.attributes.image" :src="`/images/client/got-me-hookd/cart-item-${item.type}.svg`" width="46" height="46" :alt="item.type")
                                .re-cart-item-titles
                                    .cart-item-title
                                        template(v-if="screenSM") {{ item.attributes.title || item.attributes.product.title }}
                                        fit-truncate-text-control(v-else) {{ item.attributes.title || item.attributes.product.title }}
                                .re-cart-item-quantity
                                    div.re-cart-item-quantity-change(v-if="itemCountChangeable(item)" @click="changeItemCount(item, -1)" :disabled="(item.count || 1) <= 1")
                                        svg-icon(iconId="cart-minus")
                                    span.re-cart-item-quantity-count {{ item.payload.count || 1 }}
                                    div.re-cart-item-quantity-change(v-if="itemCountChangeable(item)" @click="changeItemCount(item, +1)")
                                        svg-icon(iconId="cart-plus")
                                .re-cart-item-total.re-cart-item-actions
                                    .re-cart-item-amount {{ item.total | currency }}
                                    img.cart-item-delete(v-if="!showPurchasedItems" @click="itemDelete($event, item)" src="/images/client/got-me-hookd/cart-item-delete.svg" width="24" height="24")

</template>

<script>
import { MatchMedia } from 'vue-component-media-queries'
import ReCartList from 'utils/vue/components/complex/cart/general/re-cart-list/script.js'
import { EventBus } from 'utils/vue/components/complex/cart/general/re-cart-list/config.js'

export default {
    name: 'gmh-cart-list',

    components: {
        MatchMedia,
    },

    mixins: [
        ReCartList,
    ],

    data() { return {
        showPurchasedItems: false,
        purchasedItems: null,
    }},

    computed: {
        displayedCartItems() {
            return this.showPurchasedItems ? this.purchasedItems : this.currentCartItems
        },
    },

    created() {
        EventBus.$on('cart.paying', () => {
            this.purchasedItems = this.currentCartItems
        })

        EventBus.$on('cart.paid', () => {
            this.showPurchasedItems = true
        })
    },

    methods: {
        itemDelete($event, item) {
            this.cartItemButtonClicked({
                $event,
                actionName: 'delete',
                id: item.id,
                item,
                cartItems: this.currentCartItems,
                button: {}
            })
        },

        itemCountChangeable(item) {
            return item.type == 'creator'
        },

        async changeItemCount(item, change) {
            const count = (item.count || 1) + change

            if (count > 0) {
                this.$store.dispatch('Shop/Orders/Cart/setCartItemCount', {
                    id: item.id,
                    count
                })

                await this.validateCart()
            }
        },

        getCartItemClass(item) {
            return {
                [`re-cart-item--${item.type}-type`]: true,
                're-cart-item--count-changable': this.itemCountChangeable(item),
            }
        },

        getItemImageStyle(src) {
            if (src) {
                return {
                    'background-repeat': 'no-repeat',
                    'background-size': 'cover',
                    'background-position': 'center',
                    'background-image': `url(${src})`,
                }
            }
        },
    }
}
</script>
